import React from 'react';
import inl from './inl-link.png'
import './App.css';
import Helmet from 'react-helmet';

function App() {
  return (
    <>
    <div className="container">
          <div className="inl-load medium" style={{margin: 'auto'}}>
              <div className="ring ring-1"></div>
              <div className="ring ring-2"></div>
              <div className="ring ring-3"></div>
              <img className="ring logo" src={inl} />
          </div>
          <div className="title">Imagine No Limit Technology</div>
          <div className="subtitle"></div>
          <div className="text">
            <strong>Our Product</strong><br />
            <a href="https://www.iedu.in.th" title="iEducation Suite">iEducation Suite</a>
          </div>
          <div className="text">
            <strong>Contact Us</strong><br />
            <a href="https://www.facebook.com/INLTech/">Facebook Page</a>{' | '}
            <a href="mailto:techno@inl.in.th">E-Mail</a>
          </div>
        </div>
    <div className="App">
      <Helmet title="Imagine No Limit Technology" />
    </div>
    </>
  );
}

export default App;
